import template from './floors-count.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.floorsCount', [])
    .directive('cianAfAboutBuildingFloorsCount', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.floorsMin = 1;
            this.floorsMax = 1000;

            this.validation = validation(this.form, 'building.floorsCount', {
                parse: 'Введите число',
                required: 'Введите количество этажей',
                min: `Количество этажей не может быть меньше ${this.floorsMin}`,
                max: 'Допустимо не более 3 символов',
            });
        },
        controllerAs: 'floorsCount',
        template,
    }))
    .name;
